import React from 'react';
import ContactSection from '../../components/lp/ContactSection';

const PublicContact = () => (
  <div className="py-8">
    <ContactSection />
  </div>
);

export default PublicContact;
